module.exports = __webpack_public_path__ + "media/images/pro-big-cccd1cbf4b21b5d9c802cb24251c3710.png";